import React from 'react';
import './Loading.css'; // Make sure to create this CSS file

const Loading = ({text}) => (
  <div className="loading-overlay">
   
    <div className="loading-popup">
    <div className="center-spinner">
    <div className="spinner2"></div>
      <div className="text">{/* text */}</div>
      </div>
  </div>
  </div>
);

export default Loading;
